import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getMasterPolicyList, removeMasterPolicy } from "../../../services/ApiService";
import { api } from "../../../utils/api";
import { goToPage, promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import CustomTable from "../../components/CustomTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const MasterPolicySettings = (props) => {
    const lang = props.lang;
    const history = useHistory();
    const location = useLocation();
    const tableColumns = [
        {
            Header: translate(lang, 'index'),
            accessor: (row, index) => {
                return index + 1;
            }
        },  
        {
            Header: translate(lang, 'name'),
            accessor: (row, index) => {
                return row.name;
            }
        },
        {
            Header: translate(lang, 'displayType'),
            accessor: (row, index) => {
                return row.dataDisplay === "ring" ? "Ring" : "Bar Chart";
            }
        },
        {
            Header: translate(lang, 'term'),
            accessor: (row, index) => {
                return row.key;
            }
        },
        {
            Header: translate(lang, 'icon'),
            accessor: (row, index) => {
                return <><img src={`${api.policyMasterIcon + "/" + row.icon}`} alt="icon" className="rounded-2" width="50px" height="50px"></img></>;
            }
        },
        {
            Header: translate(lang, 'action'),
            accessor: (row, index) => {
                return (<>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">{translate(props.lang, "View Master Policy")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/settings/master-policy/view/${row.slug}`, pageNumber, productPerpage, filterInput)}
                                // to={`/settings/master-policy/view/${row.slug}`}
                                className="btn btn-primary shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-eye"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-3">{translate(props.lang, "Edit Master Policy")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/settings/master-policy/edit/${row.slug}`, pageNumber, productPerpage, filterInput)}
                                // to={`/settings/master-policy/edit/${row.slug}`}
                                className="btn btn-warning shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-pen"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-4">{translate(props.lang, "Delete Master Policy")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <span
                                ref={ref} {...triggerHandler}
                                onClick={() => removeItem(row.id)}
                                className="btn btn-danger shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-trash"></i>
                            </span>
                        )}
                    </OverlayTrigger>
                   
                </>)
            }
        },
    ]
    const [filterInput, setFilterInput] = useState(""); 
    const [pageNumber, setPageNumber] = useState(1);
    const [productPerpage, setProductPerpage] = useState(10);
    const [data, setData] = useState([]);
    const [fileData, setFileData] = useState({
        name: "master_policy",
        excelData: [],
        hasCustom: false,
        customRows: [{
            customData: [],
            origin: -1, // last row or specified location like 'A1'
        }],
    });

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        let query = {};
        let res = await getMasterPolicyList(query);
        if (res?.status === 'success') {
            setData([...res.data])
            setFileData([...res.data])
        } else {
        }
    }

    function removeItem(id) {
        Swal.fire({
            title: translate(props.lang,"deleteConfirmation"),
            text: translate(props.lang,"deleteMessage"),
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await removeMasterPolicy(id)
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message)
                    getList();
                } else {
                    promptMessage(lang, 'error', res.message)
                    getList();
                }
            }
        })
    }

    return (
        <>
            <div className="card shadow">
                <div className="card-header">
                    <div>
                        <div onClick={()=>goToPage(`/settings/master-policy/create`, pageNumber, productPerpage, filterInput)} className="btn btn-primary btn-sm rounded-2 py-2">{translate(lang, 'createMasterPolicy')}</div>
                    </div>
                </div>
                <div className="card-body">
                    <div id="job_data" className="dataTables_wrapper">
                        <CustomTable
                            lang={props.lang}
                            columns={tableColumns}
                            data={data}
                            excelExport={false}
                            fileData={fileData}
                            history={history}
                            location={location}
                            updatePageNumber={(page) => setPageNumber(page+1)}
                            updatePageLimit={(limit) => setProductPerpage(limit)}
                            pageNumber={pageNumber}
                            pageLimit={productPerpage}
                            updateFilter={(value) => setFilterInput(value)}
                            filterInput={filterInput}
                        ></CustomTable>
                    </div>
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(MasterPolicySettings);